export default __webpack_public_path__ + "static/media/69.0626065b.png";